import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NAVIGATION } from '../../core/navigation/navigation.config';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Sidebar } from '../sidebar/sidebar';

@Component({
  selector: 'app-page-selector',
  imports: [RouterLink, RouterLinkActive, Sidebar],
  templateUrl: './page-selector.html',
  styleUrl: './page-selector.scss',
})
export class PageSelector {
  navItems = NAVIGATION();

  sidebarOpen = false;

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  closeSidebar() {
    this.sidebarOpen = false;
  }
}
